import styles from "Styles/components/error-message.module.css";

export default function ErrorMessage({ text = "請填寫必填欄位" }) {
  return (
    <div className={styles.errorTextWrapper}>
      <svg
        width="18"
        height="18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 3a6 6 0 1 0 0 12A6 6 0 0 0 9 3Zm0 11a5 5 0 1 1 0-9.999A5 5 0 0 1 9 14Z"
          fill="#D71818"
        />
        <path
          d="M9 10.035a.65.65 0 0 1-.65-.65v-3a.65.65 0 1 1 1.3 0v3a.65.65 0 0 1-.65.65ZM8.975 12.26a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
          fill="#D71818"
        />
      </svg>
      <span className={styles.errorText}>{text}</span>
    </div>
  );
}
